export var ACTION;
(function (ACTION) {
    ACTION["BACK_BUTTON"] = "BACK_BUTTON";
    ACTION["NAVIGATE_TO_PAYMENT"] = "NAVIGATE_TO_PAYMENT";
    ACTION["NAVIGATE_TO_FORECLOSURE"] = "NAVIGATE_TO_FORECLOSURE";
    ACTION["FAQ_INSTRUMENT"] = "FAQ_INSTRUMENT";
})(ACTION || (ACTION = {}));
